"use client";

import { useVersionCheck } from "@/hooks/useVersionCheck";
import { VersionMismatchModal } from "@/components/common/VersionMismatchModal";

export const VersionCheckWrapper = () => {
  const { shouldReload, dismissVersion } = useVersionCheck({
    checkInterval: 30 * 1000,
    pauseWhenInactive: true,
  });

  const handleReload = () => {
    // Clear cache and reload
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    dismissVersion();
  };

  return (
    <VersionMismatchModal
      open={shouldReload}
      onReload={handleReload}
      onDismiss={handleDismiss}
    />
  );
};
